import { render } from "./chapters.vue?vue&type=template&id=abdefe4e&ts=true"
import script from "./chapters.vue?vue&type=script&lang=ts"
export * from "./chapters.vue?vue&type=script&lang=ts"

import "./chapters.vue?vue&type=style&index=0&id=abdefe4e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__